import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo-bg.png';
import { SITE } from '../content/site';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'The Problem', path: '/problem' },
    { name: 'Scorecard', path: '/scorecard' },
    { name: 'Sentinel', path: '/sentinel' },
    { name: 'Forecaster', path: '/forecaster' },
    { name: 'Notes', path: '/notes' },
    { name: 'Data & Methods', path: '/methods' },
    { name: 'Contribute', path: '/contribute' },
    { name: 'About', path: '/about' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container-width px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-4">
          {/* Logo + wordmark */}
          <Link to="/" className="flex items-center space-x-3">
            <img src={logo} alt="Cardinal Grid" className="h-12 w-auto" />
            <div className="flex flex-col leading-tight">
              <span className="text-lg font-poppins font-bold text-primary-red tracking-wide">CARDINAL GRID</span>
              <span className="text-xs font-montserrat font-medium text-light-blue uppercase tracking-widest">
                {SITE.kicker}
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`font-montserrat font-medium text-sm transition-colors duration-300 ${
                  isActive(item.path)
                    ? 'text-primary-red border-b-2 border-primary-red'
                    : 'text-dark-gray hover:text-primary-red'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <a href={SITE.github} target="_blank" rel="noopener noreferrer" className="btn-primary text-sm py-2 px-4">
              GitHub
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden flex flex-col space-y-1"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`block w-6 h-0.5 bg-dark-gray transition-transform ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-dark-gray transition-opacity ${isMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-dark-gray transition-transform ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden bg-white border-t border-lighter-gray">
            <nav className="py-4 space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`block px-4 py-2 font-montserrat font-medium transition-colors duration-300 ${
                    isActive(item.path) ? 'text-primary-red bg-red-50' : 'text-dark-gray hover:text-primary-red hover:bg-gray-50'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <div className="px-4 pt-2">
                <a
                  href={SITE.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary w-full text-center inline-block"
                  onClick={() => setIsMenuOpen(false)}
                >
                  GitHub
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
